import React, { useState, useEffect, useMemo, useRef } from 'react';
import './AdminDashboard.scss';
import DateFilter from '../DateFilter';
import Modal from '../Modal/Modal';
import { getAllUsersData } from '../../helper/helper';
// import { endOfMonth, differenceInDays, startOfMonth, parseISO } from 'date-fns';
import TargetAchievedWidget from './TargetAchievedWidget';
import DashboardCharts from './DashboardCharts';
import DashboardTable from './DashboardTable';
import { removeDuplicatesByInvoice } from '../ReusableFunctions';
import {
  ADMIN_ROLE,
  calculateAdjustedTargetByDates,
  calculateTarget,
  EMPLYEE_ROLE,
  filterEventCisData,
  filterTargetData,
  // findKeyByValue,
  keysToSum,
  MANAGER_ROLE,
} from './utils';
import { capitalize } from '../utils/TextFilter';
import { storeNameList } from '../../Container/utils';
import toast from 'react-hot-toast';
import useTargetsCounts from '../../customHooks/useTargetsCounts';

const type = ['Select Type', 'Stores', 'Reps', 'All'];

const AdminDashboard = () => {
  const username = useMemo(() => localStorage.getItem('username'), []);
  const userDetails = useMemo(() => JSON.parse(localStorage.getItem('user_data')), []);

  const [cisdata, setCisdata] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [target, setTarget] = useState([]);
  // const [targetRow, setTargetRow] = useState([]);
  const [adjustedtarget, setAdjustedtarget] = useState([]);
  const [storeCommission, setStoreCommission] = useState([]);
  const [currentFilter, setCurrentFilter] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [employeeCommissions, setEmployeeCommissions] = useState([]);
  const [typeSelected, setTypeSelected] = useState('All');
  const [currentMandY, setCurrentMandY] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [accMSRPDataAA, setAccMSRPDataAA] = useState([]);
  const [accMSRPDataOA, setAccMSRPvDataOA] = useState([]);
  // const [totalAccMSRP, setTotalAccMSRP] = useState(null);
  // const [value1, setValue1] = useState(0);
  // const [value2, setValue2] = useState(0);
  const [userdata, setUserdata] = useState([]);
  // const [userDetail, setUserDetail] = useState(null);
  const [accListAR, setAccListAR] = useState([]);
  const [accListOA, setAccListOA] = useState([]);
  const [eventCisData, setEventCisData] = useState([]);
  const [incomingDate, setIncomingDate] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const currentDates = useRef();

  const [userList, setuserList] = useState([]);
  useEffect(() => {
    async function fetchUser() {
      let { data } = await getAllUsersData();
      setuserList(data);
    }
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  // useEffect(() => {
  //   async function fetchUser() {
  //     let { data } = await getUser({ username: username });
  //     setUserDetail(data);
  //   }
  //   if (username) {
  //     fetchUser();
  //   }
  // }, [username]);

  useEffect(() => {
    async function fetchData() {
      try {
        if (userDetails?.role === 'manager') {
          let finalArray = [];
          userDetails?.stores?.split(',').forEach((store) => {
            userList.forEach((user) => {
              let exist = user?.stores.split(',').some((item) => item === store);
              if (exist && user?.role !== 'manager') finalArray.push(user);
            });
          });
          setUserdata(finalArray);
        } else if (userDetails?.role === 'admin') {
          setUserdata(data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username,userList]);

  const setLoadingCondition = (condition) => {
    setIsLoading(condition);
  };

  const DateForTarget = (target, dates) => {
    setIncomingDate(dates);
    let filteredTarget = target;

    if (userDetails?.role === EMPLYEE_ROLE) {
      filteredTarget = target?.filter((val) => val.username === username);
    } else if (userDetails?.role === MANAGER_ROLE) {
      filteredTarget = target?.filter((val) =>
        userDetails?.stores?.split(',').some((store) => store === val.storeinvoice),
      );
    }

    setTarget(filteredTarget);
    const result = calculateTarget(filteredTarget);
    // setTargetRow(result);
    setAdjustedtarget(calculateAdjustedTargetByDates(dates, result));
  };

  const accessoryListAR = (data) => {
    if (data.length > 0) {
      setAccListAR(data);
    }
  };

  const accessoryListOA = (data) => {
    if (data.length > 0) {
      setAccListOA(data);
    }
  };

  const AAMSRP = (data) => {
    setAccMSRPDataAA(data);
    // let totalMsrp = 0;
    // for (const key in data[1]) {
    //   if (data[1].hasOwnProperty(key)) {
    //     totalMsrp += data[1][key].msrp;
    //   }
    // }
    // setValue1(totalMsrp);
  };

  const OAMSRP = (data) => {
    setAccMSRPvDataOA(data);
    // let totalMsrpOA = 0;
    // for (const key in data[1]) {
    //   if (data[1].hasOwnProperty(key)) {
    //     totalMsrpOA += data[1][key].OAMsrp;
    //   }
    // }
    // setValue2(totalMsrpOA);
  };

  const updateTableData = (data) => {
    let finalArray = data || [];
    if (userDetails?.role === EMPLYEE_ROLE) {
      finalArray = finalArray.filter((val) => val.user === username);
      const duplicateRemoved = removeDuplicatesByInvoice(finalArray);
      setCisdata(duplicateRemoved);
      setEmployeeData(duplicateRemoved);
      // let sums = sumValues(accMSRPDataAA[1], accMSRPDataOA[1])
      // setTotalAccMSRP(sums?.grandTotal);
    } else if (userDetails?.role === MANAGER_ROLE) {
      finalArray = finalArray.filter((val) =>
        userDetails?.stores.split(',').includes(val.storeInvoice),
      );
      const duplicateRemoved = removeDuplicatesByInvoice(finalArray);
      setCisdata(duplicateRemoved);
      setEmployeeData(duplicateRemoved);
      setEmployeeCommissions(duplicateRemoved);
    } else {
      setCisdata(finalArray);
      setEmployeeData(finalArray);
      setStoreCommission(finalArray);
      setEmployeeCommissions(finalArray);
    }
  };

  const onEventDataLoaded = (data) => {
    // If empty than not updating eventcis data, when it should be empty it means no event data found
    if (data) {
      let filteredData = data;
      if (userDetails?.role === EMPLYEE_ROLE) {
        filteredData = data.filter((val) => val.user === username);
      } else if (userDetails?.role === MANAGER_ROLE) {
        filteredData = data.filter((val) =>
          userDetails?.stores.split(',').includes(val.storeInvoice),
        );
      }
      setEventCisData(filteredData);
    }
  };

  const currentMonthYear = (data) => {
    setCurrentMandY(data);
  };

  const cisAndTargetData = (data) => {
    setEmployeeData(data[0]);
    setEmployeeCommissions(data[0]);

    const result = data[1].reduce((acc, item) => {
      keysToSum.forEach((key) => {
        acc[key] = (acc[key] || 0) + parseInt(item[key], 10);
      });
      return acc;
    }, {});

    // setTargetRow(result);
    setAdjustedtarget(calculateAdjustedTargetByDates(incomingDate, result));
    // setAdjustedtarget(result);
    if (userDetails?.role === ADMIN_ROLE) {
      setStoreCommission(data[0]);
    }
  };

  const currentFilteritmes = (data) => {
    setCurrentFilter(data);

    // Refactoring as it only seems to change TotalAccMSRP

    // const emailPrefix = data[0] + '@vyadom.com';
    // if (data[0] && data[1] === undefined) {
    //   setTotalAccMSRP(
    //     (accMSRPDataAA?.[1]?.[emailPrefix]?.msrp || 0) +
    //       (accMSRPDataOA?.[0]?.[emailPrefix]?.OAMsrp || 0),
    //   );
    // } else if (data[1] && data[0] === '') {
    //   const key = findKeyByValue(storeNameList, data[1]);
    //   setTotalAccMSRP(
    //     (accMSRPDataAA?.[0]?.[key]?.msrp || 0) + (accMSRPDataOA?.[1]?.[key]?.OAMsrp || 0),
    //   );
    // } else if (data[1] && data[0]) {
    //   const key = findKeyByValue(storeNameList, data[1]);
    //   setTotalAccMSRP(
    //     (accMSRPDataAA?.[2]?.[emailPrefix]?.[key]?.msrp || 0) +
    //       (accMSRPDataOA?.[2]?.[key]?.[emailPrefix]?.OAMsrp || 0),
    //   );
    // }
  };

  let filterStores = [];
  let storesList = cisdata?.map((store) => store.storeInvoice);
  storesList?.forEach((val) => {
    let isExist = filterStores.some((store) => store === val);
    if (!isExist) filterStores.push(val);
  });
  const sortedStores = filterStores.sort((a, b) => a.localeCompare(b));

  const sortedEmployees = Array.from(
    new Set(
      [...cisdata, ...eventCisData]
        ?.map((emp) => emp.user)
        .filter((user) => {
          if (!user || user === 'admin@vyadom.com') return false;
          if (userDetails.role === MANAGER_ROLE) {
            const foundUser = userList.find((u) => u.username === user);
            if (!foundUser) return false;
            const userStores = foundUser.stores?.split(',') || [];
            const currentUserStores = userDetails.stores?.split(',') || [];
            return userStores.some((store) => currentUserStores.includes(store));
          }
          return true;
        }),
    ),
  ).sort((a, b) => a.localeCompare(b));

  // function sumValues(obj1, obj3) {
  //   let totalMsrp = 0;
  //   let totalOAMsrp = 0;
  //   for (const key in obj1) {
  //     if (obj1.hasOwnProperty(key)) {
  //       totalMsrp += obj1[key].msrp;
  //     }
  //   }
  //   for (const key in obj3) {
  //     if (obj3.hasOwnProperty(key)) {
  //       totalOAMsrp += obj3[key].OAMsrp;
  //     }
  //   }
  //   return { totalMsrp, totalOAMsrp, grandTotal: totalMsrp + totalOAMsrp };
  // }

  const handleTypeChange = (event) => {
    const { value } = event.target;
    setEmployeeCommissions('');
    setStoreCommission('');
    if (value !== 'Select Type' && value !== 'All') {
      setTypeSelected(value);
      openModal();
    } else {
      setCurrentFilter('');
      setStoreCommission(cisdata);
      setEmployeeCommissions(cisdata);
      setEmployeeData(cisdata);
      setTypeSelected(value);

      const result = target.reduce((acc, item) => {
        keysToSum.forEach((key) => {
          acc[key] = (acc[key] || 0) + parseInt(item[key], 10);
        });
        return acc;
      }, {});
      // setTargetRow(result);

      setAdjustedtarget(calculateAdjustedTargetByDates(incomingDate, result));

      // const sums = sumValues(accMSRPDataAA[1], accMSRPDataOA[1]);
      // setTotalAccMSRP(sums.grandTotal);
    }
  };
  const handleStoreChange = (event) => {
    const { value } = event.target;

    // Fetch employee data based on the selected ID
    if (value !== '') {
      const data = cisdata.filter((item) => item.storeInvoice === value);
      const targetData = target?.filter((item) => item.storeinvoice === value);
      const results = calculateTarget(targetData);
      // setTargetRow(results);
      setAdjustedtarget(calculateAdjustedTargetByDates(incomingDate, results));
      setEmployeeData(data);
      if (results.hasOwnProperty('postpaidtarget') === false) {
        toast.error(`You don't have Targets set for ${storeNameList[value.trim()]}`);
      }
      currentFilteritmes([username.slice(0, -11), storeNameList[value.trim()]]);
    } else {
      const results = calculateTarget(target);
      // setTargetRow(results);
      setAdjustedtarget(calculateAdjustedTargetByDates(incomingDate, results));
      setEmployeeData(cisdata);
      currentFilteritmes('');
      // const sums = sumValues(accMSRPDataAA[1], accMSRPDataOA[1]);
      // setTotalAccMSRP(sums.grandTotal);
    }
  };

  // const datesSelected = (data) => {
  //   setIncomingDate(data);
  //   //   const selectedStartDate = parseISO(data?.startDate);
  //   //   const selectedEndDate = parseISO(data?.endDate);
  //   //   const totalDaysInMonth =
  //   //     differenceInDays(endOfMonth(selectedStartDate), startOfMonth(selectedStartDate)) + 1;

  //   //   const selectedDays = differenceInDays(selectedEndDate, selectedStartDate) + 1;
  //   //   if (totalDaysInMonth !== selectedDays) {
  //   //     const resultForSelectedDays = {};
  //   //     Object.keys(targetRow).forEach((key) => {
  //   //       const valueForSelectedDays = (targetRow[key] / totalDaysInMonth) * selectedDays;
  //   //       resultForSelectedDays[key] = Math.round(valueForSelectedDays);
  //   //     });

  //   //     setAdjustedtarget(resultForSelectedDays);
  //   //   }
  // };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setTypeSelected('');
  };

  let filteredTarget = filterTargetData(target, 'storename', 'username', currentFilter[0] || '', currentFilter[1]|| '');
  let filteredEventCisData = filterEventCisData(eventCisData, 'storeFullName', 'user', currentFilter[0] || '', currentFilter[1]|| '');
  const { data, dataEvent } = useTargetsCounts(employeeData, filteredEventCisData, accListAR,currentFilter);

  return (
    <div className="adminsdashboard">
      <div className="filter-menu-list">
        <div className="filter-menu">
          <DateFilter
            // datesSelected={datesSelected}
            onEventDataLoaded={onEventDataLoaded}
            accessoryListAR={accessoryListAR}
            accessoryListOA={accessoryListOA}
            AAMSRP={AAMSRP}
            OAMSRP={OAMSRP}
            onDataLoaded={updateTableData}
            targetData={DateForTarget}
            /* manualData={manualAcceandAppleCare} */ currentMonth={currentMonthYear}
            setLoadingCondition={setLoadingCondition}
            dataLoading={(value) => {
              setDataLoading(value);
              setTypeSelected('All');
              setCurrentFilter([]);
            }}
            getDates={(dates) => {
              currentDates.current = dates;
            }}
            userList={userList}
          />
        </div>
        {userDetails?.role === EMPLYEE_ROLE ? (
          cisdata.length > 0 &&
          filterStores.length > 1 && (
            <>
              <div className="filter-menu">
                <label htmlFor="storeslist">Store:</label>
                <select name="storeslist" id="storeslist" onChange={handleStoreChange}>
                  <option value=""> All Stores</option>
                  {filterStores.map((storeslist) => (
                    <option value={storeslist} key={storeslist}>
                      {storeNameList[storeslist.trim()]}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )
        ) : (
          <div className="filter-menu">
            <label htmlFor="storeslist">Search By:</label>
            <select
              name="storeslist"
              id="storeslist"
              onChange={handleTypeChange}
              value={typeSelected}
            >
              {/* <option value=''>Select Type</option> */}
              {type.map((typeName) => (
                <option
                  key={typeName}
                  value={typeName}
                  style={{
                    display:
                      (typeName === type[0] || (typeName === type[1] && sortedStores.length === 1)) && 'none'
                  }}
                >
                  {typeName}
                </option>
              ))}
            </select>
            <Modal
              isOpen={modalOpen}
              onClose={closeModal}
              type={typeSelected}
              data={cisdata}
              filterStores={sortedStores}
              filterEmployees={sortedEmployees}
              target={target}
              onLoadedData={cisAndTargetData}
              currentFilteritmes={currentFilteritmes}
              userdata={userdata}
              loader={dataLoading}
            />
            <div className="labelFilter">
              {currentFilter[1] && (
                <span>
                  <span className="label">Store:</span> {capitalize(currentFilter[1])}
                </span>
              )}
              {currentFilter[0] && (
                <span>
                  <span className="label">Rep:</span> {capitalize(currentFilter[0])}
                </span>
              )}
            </div>

            {/*   {currentFilter[0] && <div className="labelFilter">Rep: {currentFilter[0]}</div>}
          {currentFilter[1] && <div className="labelFilter">Store: {currentFilter[1]}</div>}
           */}
          </div>
        )}
      </div>
      <TargetAchievedWidget
        adjustedtarget={adjustedtarget}
        data={data}
        target={calculateTarget(filteredTarget)}
        dataEvent={dataEvent}
        currentFilter={currentFilter}
        accMSRPDataAA={accMSRPDataAA}
        accMSRPDataOA={accMSRPDataOA}
        // totalAccMSRP1={totalAccMSRP}
        // value1={value1}
        // value2={value2}
        currentMandY={currentMandY}
        incomingDate={incomingDate}
      />

      <DashboardCharts
        currentFilter={currentFilter}
        isLoading={isLoading}
        employeeData={employeeData}
        accListAR={accListAR}
        accListOA={accListOA}
        eventCisData={filteredEventCisData}
        adjustedtarget={adjustedtarget}
        data={data}
        dataEvent={dataEvent}
        typeSelected={typeSelected}
        employeeCommissions={employeeCommissions}
        target={target}
        storeCommission={storeCommission}
        datesString={`${currentDates.current?.startDate}_${currentDates.current?.endDate}`}
      />

      <DashboardTable
        employeeData={employeeData}
        csvFileName={`ActivationList_${currentDates.current?.startDate}-${currentDates.current?.endDate}`}
      />
    </div>
  );
};

export default AdminDashboard;
